import React, { useState } from 'react';
import { InputTextStyled, InputTextWrapper, ErrorText } from './styles';

export const InputText = React.forwardRef(
  (
    {
      width,
      height = 40,
      fontWeight = 'normal',
      isLoading = false,
      isDisabled,
      type = 'text',
      error,
      errorColor,
      ...props
    },
    ref,
  ) => {
    const [showPassword, setShowPassword] = useState(false);
    const eyeIcon = showPassword ? 'fa-eye-slash' : 'fa-eye';
    const renderPasswordType = () => {
      if (type === 'password') {
        return showPassword ? 'text' : 'password';
      }
      return type;
    };

    return (
      <InputTextWrapper>
        <div style={{ position: 'relative', width: '100%' }}>
          <InputTextStyled
            {...props}
            width={width}
            height={height}
            ref={ref}
            isLoading={isLoading}
            disabled={isLoading || isDisabled}
            fontWeight={fontWeight}
            type={renderPasswordType()}
          />
          {type === 'password' && (
            <span
              style={{
                position: 'absolute',
                top: '50%',
                right: '10px',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                color: '#6c757d',
              }}
              onClick={() => setShowPassword(!showPassword)}
              className={`fa ${eyeIcon}`}
            />
          )}
        </div>
        {error && <ErrorText errorColor={errorColor}>{error}</ErrorText>}
      </InputTextWrapper>
    );
  },
);

InputText.displayName = 'InputText';
